module.exports = __webpack_public_path__ + "assets/b4770d12eb040e3045432e6569f7a9a2.png";